module.exports = __webpack_public_path__ + "static/media/9.cec470ec.jpg";